import { createFileRoute } from "@tanstack/react-router";
import { CollectionsIndex, collectionsIndexLoader, collectionsIndexHeadEn } from "@/pages/CollectionsIndex";

export const Route = createFileRoute("/en/collections/")({
  loader: collectionsIndexLoader,
  head: collectionsIndexHeadEn,
  component: CollectionsIndex,
});
